document.addEventListener('DOMContentLoaded', () => {
  const candidates = [...document.querySelectorAll('#shopify-section-top-bar p, .t4s-top-bar p, .t4s-announcement-bar p')];
  const rotator = candidates.find((node) => node.querySelectorAll(':scope > span').length > 1);
  if (!rotator) return;
  const messages = [...rotator.querySelectorAll(':scope > span')];
  let active = 0;
  rotator.classList.add('cos-announcement-rotator');
  messages.forEach((message, index) => {
    message.classList.toggle('is-active', index === 0);
    message.setAttribute('aria-hidden', String(index !== 0));
  });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.setInterval(() => {
    const previous = active;
    active = (active + 1) % messages.length;
    messages[previous].classList.add('is-leaving');
    messages[previous].classList.remove('is-active');
    messages[previous].setAttribute('aria-hidden', 'true');
    window.setTimeout(() => messages[previous].classList.remove('is-leaving'), 650);
    messages[active].classList.add('is-active');
    messages[active].setAttribute('aria-hidden', 'false');
  }, 5000);
});
document.addEventListener('DOMContentLoaded', () => {
  const categorySection = document.querySelector('[id*="collections_list_CQVrJh"]');
  const categoryGrid = categorySection?.querySelector('.t4s-list-collections');
  if (!categorySection || !categoryGrid || categorySection.querySelector('.cos-category-viewall')) return;
  const action = document.createElement('div');
  action.className = 'cos-category-viewall';
  action.innerHTML = '<a href="/collections">View all categories <span aria-hidden="true">→</span></a>';
  categoryGrid.insertAdjacentElement('afterend', action);
});
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.createElement('div');
  modal.className = 'cos-search-modal';
  modal.hidden = true;
  modal.innerHTML = `
    <div class="cos-search-modal__backdrop" data-cos-search-close></div>
    <section class="cos-search-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="cos-search-title">
      <header class="cos-search-modal__head">
        <div><span>Discover your next favourite</span><h2 id="cos-search-title">Search Cosmetica</h2></div>
        <button type="button" class="cos-search-modal__close" data-cos-search-close aria-label="Close search">×</button>
      </header>
      <form class="cos-search-modal__form" action="/search" method="get" role="search">
        <input type="hidden" name="type" value="product">
        <input name="q" type="search" autocomplete="off" placeholder="Search products, brands or concerns" aria-label="Search products" required>
        <button type="submit" aria-label="Submit search"><span>Search</span><b aria-hidden="true">⌕</b></button>
      </form>
      <div class="cos-search-modal__content">
        <div class="cos-search-modal__recent" hidden><h3>Recent searches</h3><div class="cos-search-chips" data-cos-recent></div></div>
        <div><h3>Popular brands</h3><div class="cos-search-chips cos-search-chips--brands">
          <a href="/collections/maybelline">Maybelline</a><a href="/collections/the-ordinary">The Ordinary</a><a href="/collections/huda-beauty">HUDA BEAUTY</a><a href="/collections/cerave">CeraVe</a><a href="/collections/sheglam">SHEGLAM</a><a href="/collections/mac">MAC</a>
        </div></div>
        <div><h3>Shop categories</h3><div class="cos-search-categories">
          <a href="/search?type=product&q=cream"><span>01</span><b>Creams & treatments</b></a>
          <a href="/search?type=product&q=cleanser"><span>02</span><b>Face cleansers</b></a>
          <a href="/search?type=product&q=serum"><span>03</span><b>Serums & treatments</b></a>
          <a href="/search?type=product&q=mask"><span>04</span><b>Face masks</b></a>
        </div></div>
      </div>
    </section>`;
  document.body.appendChild(modal);
  const input = modal.querySelector('input[name="q"]');
  const recentWrap = modal.querySelector('.cos-search-modal__recent');
  const recentList = modal.querySelector('[data-cos-recent]');
  const readRecent = () => {
    try { return JSON.parse(localStorage.getItem('cosmetica_recent_searches') || '[]').slice(0, 5); }
    catch (error) { return []; }
  };
  const renderRecent = () => {
    const searches = readRecent();
    recentWrap.hidden = !searches.length;
    recentList.innerHTML = searches.map((term) => `<button type="button" data-cos-term="${String(term).replace(/"/g, '&quot;')}">${term}</button>`).join('');
  };
  const openSearch = (event) => {
    if (event) event.preventDefault();
    renderRecent();
    modal.hidden = false;
    document.body.classList.add('cos-search-open');
    window.setTimeout(() => input.focus(), 50);
  };
  window.CosmeticaOpenSearch = openSearch;
  const closeSearch = () => {
    modal.hidden = true;
    document.body.classList.remove('cos-search-open');
  };
  const bindSearchTriggers = (root = document) => {
    root.querySelectorAll?.('.cos-header-search, [data-open-search], .t4s-site-nav__search a').forEach((trigger) => {
      trigger.removeAttribute('data-drawer-delay');
      trigger.removeAttribute('data-drawer-options');
      if (trigger.dataset.cosSearchBound) return;
      trigger.dataset.cosSearchBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSearch();
      });
    });
  };
  bindSearchTriggers();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) bindSearchTriggers(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  modal.querySelectorAll('[data-cos-search-close]').forEach((trigger) => trigger.addEventListener('click', closeSearch));
  recentList.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cos-term]');
    if (!button) return;
    input.value = button.dataset.cosTerm;
    input.focus();
  });
  modal.querySelector('form').addEventListener('submit', () => {
    const term = input.value.trim();
    if (!term) return;
    const searches = [term, ...readRecent().filter((item) => item.toLowerCase() !== term.toLowerCase())].slice(0, 5);
    localStorage.setItem('cosmetica_recent_searches', JSON.stringify(searches));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) closeSearch();
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('[id*="testimonials_PcU3jq"] .t4s-flicky-slider');
  if (!slider) return;
  let paused = false;
  slider.addEventListener('mouseenter', () => { paused = true; });
  slider.addEventListener('mouseleave', () => { paused = false; });
  slider.addEventListener('focusin', () => { paused = true; });
  slider.addEventListener('focusout', () => { paused = false; });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.setInterval(() => {
    if (paused || document.hidden) return;
    slider.querySelector('.flickity-button.next, .flickity-prev-next-button.next')?.click();
  }, 5200);
});

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.toggle('cos-track-page', window.location.pathname.includes('/apps/track123'));
});

/* COSMETICA AJAX LOAD MORE (KEEP THE LISTING URL STABLE) */
const cosmeticaLoadMoreCache = new Map();
let cosmeticaLoadMoreObserver;
let cosmeticaAutoLoadLocked = false;
let cosmeticaAutoLoadScrollY = -1000;

const cosmeticaGetLoadMoreRequest = (link) => {
  const container = link?.closest('[data-ntajax-container]');
  if (!container) return null;

  let options;
  try {
    options = JSON.parse(container.getAttribute('data-ntajax-options') || '{}');
  } catch (error) {
    return null;
  }
  if (!options.isProduct || !options.id) return null;

  const requestedUrl = new URL(link.href, window.location.origin);
  requestedUrl.searchParams.set('section_id', options.id);
  return { container, options, url: requestedUrl.toString() };
};

const cosmeticaPrefetchLoadMore = (link) => {
  const request = cosmeticaGetLoadMoreRequest(link);
  if (!request) return null;

  if (!cosmeticaLoadMoreCache.has(request.url)) {
    const promise = fetch(request.url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then((response) => {
      if (!response.ok) throw new Error('Load more request failed: ' + response.status);
      return response.text();
    }).catch((error) => {
      cosmeticaLoadMoreCache.delete(request.url);
      throw error;
    });
    cosmeticaLoadMoreCache.set(request.url, promise);
  }

  return { ...request, htmlPromise: cosmeticaLoadMoreCache.get(request.url) };
};

const cosmeticaWarmLoadMore = (link) => {
  cosmeticaPrefetchLoadMore(link)?.htmlPromise.catch(() => {});
};

const cosmeticaObserveLoadMore = (scope = document) => {
  const links = scope.querySelectorAll?.('[data-ntajax-container] [data-load-more]:not([data-is-prev])');
  if (!links?.length) return;

  if ('IntersectionObserver' in window) {
    cosmeticaLoadMoreObserver ||= new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || cosmeticaAutoLoadLocked) return;
        cosmeticaAutoLoadLocked = true;
        cosmeticaAutoLoadScrollY = window.scrollY;
        cosmeticaLoadMoreObserver.unobserve(entry.target);
        cosmeticaWarmLoadMore(entry.target);
        if (!entry.target.classList.contains('is--loading')) entry.target.click();
      });
    }, { rootMargin: '700px 0px' });
    links.forEach((link) => cosmeticaLoadMoreObserver.observe(link));
  }

  const warmFirstPage = () => cosmeticaWarmLoadMore(links[0]);
  if ('requestIdleCallback' in window) requestIdleCallback(warmFirstPage, { timeout: 1800 });
  else window.setTimeout(warmFirstPage, 900);
};

document.addEventListener('DOMContentLoaded', () => cosmeticaObserveLoadMore());
window.addEventListener('scroll', () => {
  if (!cosmeticaAutoLoadLocked || Math.abs(window.scrollY - cosmeticaAutoLoadScrollY) < Math.max(240, window.innerHeight * .32)) return;
  cosmeticaAutoLoadLocked = false;
  document.querySelectorAll('[data-ntajax-container] [data-load-more]:not([data-is-prev])').forEach((link) => {
    cosmeticaLoadMoreObserver?.unobserve(link);
    cosmeticaLoadMoreObserver?.observe(link);
  });
}, { passive: true });
document.addEventListener('pointerover', (event) => {
  const link = event.target.closest?.('[data-ntajax-container] [data-load-more]:not([data-is-prev])');
  if (link) cosmeticaWarmLoadMore(link);
}, { passive: true });
document.addEventListener('touchstart', (event) => {
  const link = event.target.closest?.('[data-ntajax-container] [data-load-more]:not([data-is-prev])');
  if (link) cosmeticaWarmLoadMore(link);
}, { passive: true });

document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-ntajax-container] [data-load-more]:not([data-is-prev])');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const request = cosmeticaPrefetchLoadMore(link);
  if (!request) return;
  const { container, options, url: requestedUrl, htmlPromise } = request;

  event.preventDefault();
  event.stopImmediatePropagation();

  const stableUrl = window.location.href;
  const currentGrid = container.querySelector('[data-contentlm-replace]');
  if (!currentGrid) return;

  link.classList.add('is--loading');
  link.setAttribute('aria-disabled', 'true');
  container.setAttribute('aria-busy', 'true');

  try {
    const html = await htmlPromise;
    cosmeticaLoadMoreCache.delete(requestedUrl);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('[data-ntajax-container]');
    const nextGrid = replacement?.querySelector('[data-contentlm-replace]');
    if (!replacement || !nextGrid) throw new Error('Load more response did not contain a product grid');

    const newItems = Array.from(nextGrid.children);
    newItems.forEach((item) => currentGrid.appendChild(item));

    const currentFooter = container.querySelector('.t4s-prs-footer');
    const nextFooter = replacement.querySelector('.t4s-prs-footer');
    const hasAnotherPage = nextFooter?.querySelector('[data-load-more]:not([data-is-prev])');
    if (currentFooter) {
      if (hasAnotherPage) currentFooter.replaceWith(nextFooter);
      else currentFooter.remove();
    }

    if (window.T4SThemeSP) {
      window.T4SThemeSP.ProductItem?.init?.();
      window.T4SThemeSP.PopupMFP?.();
    }
    if (/Isotope/.test(options.type || '') && window.jQuery_T4NT) {
      const isotopeGrid = window.jQuery_T4NT(currentGrid);
      if (typeof isotopeGrid.isotope === 'function') isotopeGrid.isotope('appended', newItems).isotope('layout');
    }
    window.lazySizes?.autoSizer?.checkElems?.();
    window.jQuery_T4NT?.('body').trigger('t4s:hideTooltip').trigger('currency:update');

    if (window.location.href !== stableUrl) history.replaceState(history.state, document.title, stableUrl);
    const nextButton = container.querySelector('[data-load-more]:not([data-is-prev])');
    nextButton?.focus({ preventScroll: true });
    if (nextButton) cosmeticaObserveLoadMore(container);
  } catch (error) {
    console.error('[Cosmetica] AJAX load more failed', error);
    link.classList.remove('is--loading');
    link.removeAttribute('aria-disabled');
  } finally {
    container.removeAttribute('aria-busy');
  }
}, true);

/* COSMETICA AJAX PRODUCT PAGINATION */
document.addEventListener('click', async (event) => {
  const link = event.target.closest('[data-ntajax-container] [data-ntjax-wrap] a');
  const container = link?.closest('[data-ntajax-container]');
  if (!link || !container || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  let options;
  try {
    options = JSON.parse(container.getAttribute('data-ntajax-options') || '{}');
  } catch (error) {
    return;
  }
  if (!options.isProduct || !options.id) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const requestedUrl = new URL(link.href, window.location.origin);
  requestedUrl.searchParams.set('section_id', options.id);
  const section = document.getElementById('shopify-section-' + options.id);
  const stableUrl = window.location.href;

  container.classList.add('is--loading');
  container.setAttribute('aria-busy', 'true');
  document.body.classList.add('content--loading');

  try {
    const response = await fetch(requestedUrl.toString(), {
      headers: { 'Cache-Control': 'no-cache', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Pagination request failed: ' + response.status);

    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector('[data-ntajax-container]');
    if (!replacement) throw new Error('Pagination response did not contain a product grid');

    container.innerHTML = replacement.innerHTML;

    if (window.T4SThemeSP) {
      window.T4SThemeSP.reinitProductGridItem?.();
      window.T4SThemeSP.PopupMFP?.();
      if (/Isotope/.test(options.type || '')) {
        const isotopeGrid = container.querySelector('.isotopet4s');
        if (isotopeGrid && window.jQuery_T4NT) window.T4SThemeSP.Isotopet4s?.init(window.jQuery_T4NT(isotopeGrid));
      }
    }
    window.lazySizes?.autoSizer?.checkElems?.();
    window.jQuery_T4NT?.('body').trigger('t4s:hideTooltip').trigger('currency:update');

    if (window.location.href !== stableUrl) history.replaceState(history.state, document.title, stableUrl);
    window.scrollTo({ top: Math.max(0, (section || container).getBoundingClientRect().top + window.scrollY - 110), behavior: 'smooth' });
    container.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
  } catch (error) {
    console.error('[Cosmetica] AJAX pagination failed', error);
  } finally {
    container.classList.remove('is--loading');
    container.removeAttribute('aria-busy');
    document.body.classList.remove('content--loading');
  }
}, true);

/* COSMETICA MOBILE COLLECTION FILTERS */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.template-collection .t4s-section-main, .template-search .t4s-section-main').forEach((section) => {
    const drawer = section.querySelector('[data-cos-mobile-filter-drawer]');
    const button = section.querySelector('.t4s-btn-filter');
    if (!drawer || !button) return;
    button.setAttribute('data-cos-filter-open', '');
    button.setAttribute('aria-controls', drawer.id);
    button.setAttribute('aria-expanded', 'false');
    button.removeAttribute('data-drawer-delay');
    button.removeAttribute('data-drawer-options');
  });
});

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-cos-filter-open]');
  const closeButton = event.target.closest('[data-cos-filter-close]');

  if (openButton) {
    event.preventDefault();
    const drawer = document.getElementById(openButton.getAttribute('aria-controls'));
    if (!drawer) return;
    drawer.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('cos-filter-modal-open');
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      drawer.querySelector('.cos-mobile-filter-modal__close')?.focus();
    });
    return;
  }

  if (closeButton) {
    const drawer = closeButton.closest('[data-cos-mobile-filter-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('cos-filter-modal-open');
    document.querySelector('[aria-controls="' + drawer.id + '"]')?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => { drawer.hidden = true; }, 220);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('[data-cos-mobile-filter-drawer].is-open');
  drawer?.querySelector('[data-cos-filter-close]')?.click();
});

/* COSMETICA EASELL COD BUTTON STABILIZER
   EasySell writes red pill styles inline with !important after page load. */
(() => {
  const selector = '.es-popup-button-product,.es-popup-button-drawer,#es-form-button';
  const desired = (button) => ({
    'background-color': '#e52b91',
    'background-image': 'linear-gradient(110deg, #e52b91, #8b218d)',
    'border-radius': button.classList.contains('es-popup-button-drawer') ? '10px' : '12px',
    'border-width': '0px',
    'box-shadow': '0 9px 22px rgba(164,31,137,.18)',
    animation: 'none',
    'animation-name': 'none',
    transform: 'none'
  });

  const styleButton = (button) => {
    if (!(button instanceof Element) || !button.matches(selector)) return;
    const isUnavailableDuplicate = button.classList.contains('es-popup-button-product') && /^sold out$/i.test(button.textContent.trim());
    if (isUnavailableDuplicate) {
      button.dataset.cosUnavailableDuplicate = 'true';
      button.style.setProperty('display', 'none', 'important');
      return;
    }
    if (button.dataset.cosUnavailableDuplicate) {
      delete button.dataset.cosUnavailableDuplicate;
      button.style.removeProperty('display');
    }
    const styles = desired(button);
    Object.entries(styles).forEach(([property, value]) => {
      if (button.style.getPropertyValue(property) === value && button.style.getPropertyPriority(property) === 'important') return;
      button.style.setProperty(property, value, 'important');
    });
  };

  const styleButtons = (root = document) => {
    if (root instanceof Element && root.matches(selector)) styleButton(root);
    root.querySelectorAll?.(selector).forEach(styleButton);
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      styleButtons();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => styleButtons(), { once: true });
  else styleButtons();

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.type === 'childList' || mutation.target?.matches?.(selector))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
})();
/* COSMETICA MOBILE DISCOVERY NAVIGATION */
(() => {
  const destinations = {
    'makeup': '/search?type=product&q=makeup',
    'skin care': '/search?type=product&q=skincare',
    'skincare': '/search?type=product&q=skincare',
    'accessories': '/search?type=product&q=accessories'
  };

  const enhanceMenu = (drawer) => {
    if (!drawer) return;
    drawer.querySelectorAll('a').forEach((link) => {
      const label = link.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
      if (destinations[label]) link.href = destinations[label];
      if (label === 'home') link.href = '/';
    });
    if (drawer.querySelector('.cos-mobile-discovery')) return;
    const head = drawer.querySelector('.cos-mobile-menu-head,.t4s-drawer__header');
    if (!head) return;
    const discovery = document.createElement('div');
    discovery.className = 'cos-mobile-discovery';
    discovery.innerHTML = `
      <form action="/search" method="get" role="search" class="cos-mobile-discovery__search">
        <input type="hidden" name="type" value="product">
        <input type="search" name="q" placeholder="Find products or brands" aria-label="Find products or brands" required>
        <button type="submit" aria-label="Search"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16.5 16.5 4 4"></path></svg></button>
      </form>
      <div class="cos-mobile-discovery__links" aria-label="Popular departments">
        <a href="/search?type=product&q=makeup"><span>Makeup</span><small>Explore</small></a>
        <a href="/search?type=product&q=skincare"><span>Skin care</span><small>Explore</small></a>
        <a href="/search?type=product&q=accessories"><span>Accessories</span><small>Explore</small></a>
        <a href="/collections/all"><span>Shop all</span><small>1,400+ items</small></a>
      </div>
      <div class="cos-mobile-discovery__brands"><span>Popular:</span><a href="/collections/huda-beauty">Huda Beauty</a><a href="/collections/maybelline">Maybelline</a><a href="/collections/mac">MAC</a></div>`;
    head.insertAdjacentElement('afterend', discovery);
  };

  const scan = () => enhanceMenu(document.getElementById('t4s-menu-drawer'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
/* COSMETICA MOBILE COMMERCE STRUCTURE 2026-10-02 */
(() => {
  const mobileQuery = window.matchMedia('(max-width: 1024px)');
  const icons = {
    home: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.8 12 3l9 7.8v9.4a.8.8 0 0 1-.8.8H15v-6H9v6H3.8a.8.8 0 0 1-.8-.8z"/></svg>',
    categories: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
    offers: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12.2V5.5h6.7L21 16.3 16.3 21z"/><circle cx="7.6" cy="8.2" r="1.2"/></svg>',
    brands: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2 14.1 8l5.2.5-3.9 3.5 1.1 5.1L12 14.5l-4.5 2.6 1.1-5.1-3.9-3.5L9.9 8z"/><path d="M7.5 20.5h9"/></svg>'
  };
  const categories = `
    <details><summary><span>Brands</span><i></i></summary><div class="cos-mobile-sheet__brand-list"><strong class="cos-mobile-brand-heading">Featured Brands</strong><a href="/collections/anua">Anua</a><a href="/collections/cosrx">COSRX</a><a href="/collections/dr-althea">Dr. Althea</a><a href="/collections/medicube">Medicube</a><a href="/collections/beauty-of-joseon">Beauty of Joseon</a><a href="/collections/huda-beauty">Huda Beauty</a><a href="/collections/elf">ELF</a><a href="/collections/the-ordinary">The Ordinary</a><a href="/collections/cerave">CeraVe</a><a href="/collections/maybelline">Maybelline</a><a href="/collections/sheglam">SHEGLAM</a><a href="/collections/mac">MAC</a><a href="/collections/skin1004">SKIN1004</a><a href="/collections/charlotte-tilbury">Charlotte Tilbury</a><a href="/collections/dior">Dior</a><a href="/collections/nars">NARS</a><a href="/collections/fenty-beauty">Fenty Beauty</a><a href="/collections/rare-beauty">Rare Beauty</a><a href="/collections/nyx">NYX</a><a href="/collections/essence">Essence</a><a href="/collections/clinique">Clinique</a><a href="/collections/estee-lauder">Estée Lauder</a><a href="/collections/tarte">Tarte</a><a href="/collections/neutrogena">Neutrogena</a><a href="/collections/morphe">Morphe</a><a href="/collections/pixi">Pixi</a></div></details>
    <details><summary><span>Makeup</span><i></i></summary><div><a href="/search?type=product&q=makeup">Shop all makeup</a><a href="/search?type=product&q=foundation">Foundation</a><a href="/search?type=product&q=concealer">Concealer</a><a href="/search?type=product&q=primer">Primer</a><a href="/search?type=product&q=blush">Blush</a><a href="/search?type=product&q=mascara">Mascara</a><a href="/search?type=product&q=eyeliner">Eyeliner</a><a href="/search?type=product&q=eyeshadow">Eyeshadow</a><a href="/search?type=product&q=lipstick">Lipstick</a><a href="/search?type=product&q=lip%20gloss">Lip gloss</a><a href="/search?type=product&q=makeup%20brushes">Makeup brushes</a></div></details>
    <details><summary><span>Skincare</span><i></i></summary><div><a href="/search?type=product&q=skincare">Shop all skincare</a><a href="/search?type=product&q=cleanser">Cleansers</a><a href="/search?type=product&q=face%20wash">Face wash</a><a href="/search?type=product&q=toner">Toners</a><a href="/search?type=product&q=serum">Serums</a><a href="/search?type=product&q=moisturizer">Moisturizers</a><a href="/search?type=product&q=sunscreen">Sunscreen</a><a href="/search?type=product&q=eye%20cream">Eye care</a><a href="/search?type=product&q=face%20mask">Face masks</a><a href="/search?type=product&q=acne">Acne care</a></div></details>
    <details><summary><span>Haircare</span><i></i></summary><div><a href="/search?type=product&q=hair">Shop all haircare</a><a href="/search?type=product&q=shampoo">Shampoo</a><a href="/search?type=product&q=conditioner">Conditioner</a><a href="/search?type=product&q=hair%20mask">Hair masks</a><a href="/search?type=product&q=hair%20oil">Hair oils</a><a href="/search?type=product&q=hair%20serum">Hair serums</a><a href="/search?type=product&q=scalp">Scalp care</a><a href="/search?type=product&q=hair%20spray">Hair spray</a><a href="/search?type=product&q=hair%20styling">Styling products</a></div></details>
    <details><summary><span>Fragrance</span><i></i></summary><div><a href="/search?type=product&q=perfume">Shop all fragrance</a><a href="/search?type=product&q=women%20perfume">Women's perfume</a><a href="/search?type=product&q=men%20perfume">Men's perfume</a><a href="/search?type=product&q=unisex%20perfume">Unisex perfume</a><a href="/search?type=product&q=body%20mist">Body mists</a><a href="/search?type=product&q=body%20spray">Body sprays</a><a href="/search?type=product&q=attar">Attar</a><a href="/search?type=product&q=mini%20perfume">Miniatures</a><a href="/search?type=product&q=fragrance%20gift%20set">Gift sets</a></div></details>
    <details><summary><span>Personal Care</span><i></i></summary><div><a href="/search?type=product&q=personal%20care">Shop all personal care</a><a href="/search?type=product&q=body%20wash">Body wash</a><a href="/search?type=product&q=body%20lotion">Body lotion</a><a href="/search?type=product&q=body%20cream">Body creams</a><a href="/search?type=product&q=deodorant">Deodorants</a><a href="/search?type=product&q=hand%20care">Hand care</a><a href="/search?type=product&q=foot%20care">Foot care</a><a href="/search?type=product&q=oral%20care">Oral care</a><a href="/search?type=product&q=feminine%20care">Feminine care</a></div></details>
    <details><summary><span>K-Beauty</span><i></i></summary><div><a href="/search?type=product&q=korean">Shop all K-Beauty</a><a href="/collections/anua">Anua</a><a href="/collections/cosrx">COSRX</a><a href="/collections/skin1004">SKIN1004</a><a href="/collections/medicube">Medicube</a><a href="/collections/beauty-of-joseon">Beauty of Joseon</a><a href="/search?type=product&q=ampoule">Ampoules</a><a href="/search?type=product&q=toner%20pads">Toner pads</a><a href="/search?type=product&q=sheet%20mask">Sheet masks</a></div></details>
    <details><summary><span>Fashion</span><i></i></summary><div><a href="/search?type=product&q=fashion">Shop all fashion</a><a href="/search?type=product&q=bag">Bags</a><a href="/search?type=product&q=wallet">Wallets</a><a href="/search?type=product&q=jewelry">Jewelry</a><a href="/search?type=product&q=sunglasses">Sunglasses</a><a href="/search?type=product&q=watch">Watches</a><a href="/search?type=product&q=hair%20accessories">Hair accessories</a><a href="/search?type=product&q=fashion%20accessories">Fashion accessories</a></div></details>
    <details><summary><span>Electronics</span><i></i></summary><div><a href="/search?type=product&q=electronics">Shop all electronics</a><a href="/search?type=product&q=hair%20dryer">Hair dryers</a><a href="/search?type=product&q=straightener">Hair straighteners</a><a href="/search?type=product&q=curler">Hair curlers</a><a href="/search?type=product&q=styling%20tool">Styling tools</a><a href="/search?type=product&q=beauty%20device">Beauty devices</a><a href="/search?type=product&q=trimmer">Trimmers</a><a href="/search?type=product&q=facial%20cleaning%20device">Facial cleansing devices</a></div></details>
    <details><summary><span>Accessories</span><i></i></summary><div><a href="/search?type=product&q=accessories">Shop all accessories</a><a href="/search?type=product&q=makeup%20brushes">Makeup brushes</a><a href="/search?type=product&q=beauty%20blender">Beauty blenders</a><a href="/search?type=product&q=makeup%20bag">Makeup bags</a><a href="/search?type=product&q=beauty%20tools">Beauty tools</a><a href="/search?type=product&q=mirror">Mirrors</a><a href="/search?type=product&q=travel%20size">Travel essentials</a><a href="/search?type=product&q=organizer">Organizers</a></div></details>
    <a class="cos-mobile-sheet__direct" href="/collections/all?sort_by=created-descending"><span>Fresh Arrivals</span><b>›</b></a><a class="cos-mobile-sheet__direct" href="/collections/all?sort_by=price-ascending"><span>Offers & Discounts</span><b>›</b></a><a class="cos-mobile-sheet__direct" href="/apps/track123"><span>Track Your Order</span><b>›</b></a>`;  const brands = `<div class="cos-brand-grid"><a href="/collections/anua">Anua</a><a href="/collections/cosrx">COSRX</a><a href="/collections/dr-althea">Dr. Althea</a><a href="/collections/medicube">Medicube</a><a href="/collections/beauty-of-joseon">Beauty of Joseon</a><a href="/collections/huda-beauty">Huda Beauty</a><a href="/collections/elf">ELF</a><a href="/collections/the-ordinary">The Ordinary</a><a href="/collections/cerave">CeraVe</a><a href="/collections/maybelline">Maybelline</a><a href="/collections/sheglam">SHEGLAM</a><a href="/collections/mac">MAC</a><a href="/collections/skin1004">SKIN1004</a><a href="/collections/charlotte-tilbury">Charlotte Tilbury</a><a href="/collections/dior">Dior</a><a href="/collections/nars">NARS</a><a href="/collections/fenty-beauty">Fenty Beauty</a><a href="/collections/rare-beauty">Rare Beauty</a><a href="/collections/nyx">NYX</a><a href="/collections/essence">Essence</a><a href="/collections/clinique">Clinique</a><a href="/collections/estee-lauder">Estée Lauder</a><a href="/collections/tarte">Tarte</a><a href="/collections/neutrogena">Neutrogena</a><a href="/collections/morphe">Morphe</a><a href="/collections/pixi">Pixi</a><a href="/collections/all">View all products</a></div>`
  const closeSheets = () => {
    document.querySelectorAll('.cos-mobile-sheet.is-open').forEach((sheet) => {
      sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true');
      setTimeout(() => { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 240);
    });
    document.body.classList.remove('cos-mobile-sheet-open');
  };
  const openSheet = (name) => {
    if (!mobileQuery.matches) return;
    closeSheets();
    const sheet = document.querySelector(`[data-cos-sheet="${name}"]`);
    if (!sheet) return;
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false'); document.body.classList.add('cos-mobile-sheet-open');
    requestAnimationFrame(() => { sheet.classList.add('is-open'); sheet.querySelector('.cos-mobile-sheet__close')?.focus({ preventScroll: true }); });
  };
  const buildMobileNavigation = () => {
    if (document.querySelector('.cos-mobile-bottom-nav')) return;
    const nav = document.createElement('nav'); nav.className = 'cos-mobile-bottom-nav'; nav.setAttribute('aria-label', 'Quick navigation');
    nav.innerHTML = `<a href="/" data-cos-nav="home">${icons.home}<span>Home</span></a><button type="button" data-cos-open-sheet="categories">${icons.categories}<span>Categories</span></button><a href="/collections/all?sort_by=price-ascending" data-cos-nav="offers">${icons.offers}<span>Offers</span></a><button type="button" data-cos-open-sheet="brands">${icons.brands}<span>Brands</span></button>`;
    document.body.appendChild(nav);
    [['categories','Categories',categories],['brands','Shop by brand',brands]].forEach(([name,title,content]) => {
      const sheet=document.createElement('div'); sheet.className='cos-mobile-sheet'; sheet.dataset.cosSheet=name; sheet.hidden=true; sheet.setAttribute('aria-hidden','true');
      sheet.innerHTML=`<button class="cos-mobile-sheet__backdrop" type="button" data-cos-sheet-close aria-label="Close ${title}"></button><section class="cos-mobile-sheet__panel" role="dialog" aria-modal="true" aria-label="${title}"><header><h2>${title}</h2><button class="cos-mobile-sheet__close" type="button" data-cos-sheet-close aria-label="Close">×</button></header><div class="cos-mobile-sheet__body">${content}</div></section>`;
      document.body.appendChild(sheet);
    });
    if (location.pathname === '/') nav.querySelector('[data-cos-nav="home"]')?.classList.add('is-active');
    if (location.search.includes('sort_by=price-ascending')) nav.querySelector('[data-cos-nav="offers"]')?.classList.add('is-active');
  };
  const replaceDesktopMenu = () => {
    const menus = [
      ['Brands','/collections/all',[
        ['Popular brands',[['Maybelline','/collections/maybelline'],['Huda Beauty','/collections/huda-beauty'],['SHEGLAM','/collections/sheglam'],['MAC','/collections/mac'],['ELF','/collections/elf']]],
        ['Skincare brands',[['CeraVe','/collections/cerave'],['The Ordinary','/collections/the-ordinary'],['Medicube','/collections/medicube'],['SKIN1004','/collections/skin1004'],['Anua','/collections/anua']]],
        ['Luxury beauty',[['Charlotte Tilbury','/collections/charlotte-tilbury'],['Dior','/collections/dior'],['NARS','/collections/nars'],['Fenty Beauty','/collections/fenty-beauty'],['Rare Beauty','/collections/rare-beauty']]]
      ]],
      ['Makeup','/search?type=product&q=makeup',[
        ['Face',[['Foundation','/search?type=product&q=foundation'],['Concealer','/search?type=product&q=concealer'],['Primer','/search?type=product&q=primer'],['Powder','/search?type=product&q=face%20powder']]],
        ['Eyes',[['Mascara','/search?type=product&q=mascara'],['Eyeliner','/search?type=product&q=eyeliner'],['Eyeshadow','/search?type=product&q=eyeshadow'],['Brows','/search?type=product&q=brow']]],
        ['Lips',[['Lipstick','/search?type=product&q=lipstick'],['Lip gloss','/search?type=product&q=lip%20gloss'],['Lip liner','/search?type=product&q=lip%20liner'],['Lip balm','/search?type=product&q=lip%20balm']]],
        ['Cheeks & tools',[['Blush','/search?type=product&q=blush'],['Highlighter','/search?type=product&q=highlighter'],['Contour','/search?type=product&q=contour'],['Brushes','/search?type=product&q=makeup%20brushes']]]
      ]],
      ['Skincare','/search?type=product&q=skincare',[
        ['Cleanse',[['Cleansers','/search?type=product&q=cleanser'],['Face wash','/search?type=product&q=face%20wash'],['Makeup remover','/search?type=product&q=makeup%20remover']]],
        ['Treat',[['Serums','/search?type=product&q=serum'],['Toners','/search?type=product&q=toner'],['Face masks','/search?type=product&q=face%20mask'],['Eye care','/search?type=product&q=eye%20cream']]],
        ['Hydrate & protect',[['Moisturizers','/search?type=product&q=moisturizer'],['Sunscreen','/search?type=product&q=sunscreen'],['Face mist','/search?type=product&q=face%20mist']]],
        ['Skin concerns',[['Acne care','/search?type=product&q=acne'],['Dry skin','/search?type=product&q=hydrating'],['Dark spots','/search?type=product&q=brightening'],['Sensitive skin','/search?type=product&q=sensitive']]]
      ]],
      ['Haircare','/search?type=product&q=hair',[
        ['Wash & care',[['Shampoo','/search?type=product&q=shampoo'],['Conditioner','/search?type=product&q=conditioner'],['Hair masks','/search?type=product&q=hair%20mask']]],
        ['Treatment',[['Hair oils','/search?type=product&q=hair%20oil'],['Hair serum','/search?type=product&q=hair%20serum'],['Scalp care','/search?type=product&q=scalp']]],
        ['Styling & tools',[['Hair spray','/search?type=product&q=hair%20spray'],['Hair dryer','/search?type=product&q=hair%20dryer'],['Styling tools','/search?type=product&q=hair%20styling']]]
      ]],
      ['Fragrance','/search?type=product&q=perfume',[
        ['Perfume',[['Women’s perfume','/search?type=product&q=women%20perfume'],['Men’s perfume','/search?type=product&q=men%20perfume'],['Unisex','/search?type=product&q=unisex%20perfume']]],
        ['Mists',[['Body mist','/search?type=product&q=body%20mist'],['Fragrance mist','/search?type=product&q=fragrance%20mist'],['Body spray','/search?type=product&q=body%20spray']]],
        ['Gift ideas',[['Gift sets','/search?type=product&q=fragrance%20gift%20set'],['Miniatures','/search?type=product&q=mini%20perfume'],['Luxury fragrance','/search?type=product&q=luxury%20perfume']]]
      ]],
      ['Personal Care','/search?type=product&q=personal%20care',[
        ['Bath & body',[['Body wash','/search?type=product&q=body%20wash'],['Body lotion','/search?type=product&q=body%20lotion'],['Body cream','/search?type=product&q=body%20cream']]],
        ['Everyday care',[['Deodorant','/search?type=product&q=deodorant'],['Hand care','/search?type=product&q=hand%20cream'],['Lip care','/search?type=product&q=lip%20care']]],
        ['Accessories',[['Beauty tools','/search?type=product&q=beauty%20tools'],['Brush sets','/search?type=product&q=brush%20set'],['Travel essentials','/search?type=product&q=travel%20size']]]
      ]],
      ['K-Beauty','/search?type=product&q=korean',[
        ['Trending brands',[['Anua','/collections/anua'],['Medicube','/collections/medicube'],['SKIN1004','/collections/skin1004'],['COSRX','/collections/cosrx']]],
        ['Korean skincare',[['Toner pads','/search?type=product&q=toner%20pads'],['Ampoules','/search?type=product&q=ampoule'],['Essences','/search?type=product&q=essence'],['Sheet masks','/search?type=product&q=sheet%20mask']]],
        ['Shop by concern',[['Glass skin','/search?type=product&q=glow'],['Barrier care','/search?type=product&q=barrier'],['Pore care','/search?type=product&q=pore'],['Calming','/search?type=product&q=calming']]]
      ]],
      ['Offers','/collections/all?sort_by=price-ascending',[
        ['Shop offers',[['Best sellers','/collections/all?sort_by=best-selling'],['Lowest prices','/collections/all?sort_by=price-ascending'],['Newest products','/collections/all?sort_by=created-descending']]],
        ['Popular deals',[['Makeup deals','/search?type=product&q=makeup'],['Skincare deals','/search?type=product&q=skincare'],['Gift sets','/search?type=product&q=gift%20set']]]
      ]]
    ];
    document.querySelectorAll('.cos-header-primary-nav #t4s-nav-ul').forEach((list) => {
      if(list.dataset.cosMega==='true') return;
      list.dataset.cosMega='true';
      list.innerHTML=menus.map(([label,href,groups])=>`<li class="t4s-menu-item cos-mega-nav-item"><a href="${href}">${label}<span aria-hidden="true">⌄</span></a><div class="cos-mega-panel"><div class="cos-mega-panel__head"><strong>${label}</strong><a href="${href}">Shop all ${label} →</a></div><div class="cos-mega-panel__grid">${groups.map(([title,links])=>`<section><h3>${title}</h3>${links.map(([name,url])=>`<a href="${url}">${name}</a>`).join('')}</section>`).join('')}</div></div></li>`).join('')+`<li class="t4s-menu-item cos-mega-nav-item cos-mega-nav-item--simple"><a href="/apps/track123">Track Order</a></li>`;
    });
  };  const enhanceProductRails = (scope=document) => {
    scope.querySelectorAll?.('#MainContent .t4s-featured-collection .t4s-products').forEach((rail) => {
      if(rail.dataset.cosRail==='true'||rail.children.length<3) return; rail.dataset.cosRail='true'; rail.classList.add('cos-product-rail');
      const holder=rail.parentElement; if(!holder) return; holder.classList.add('cos-product-rail-wrap');
      const controls=document.createElement('div'); controls.className='cos-product-rail-controls'; controls.innerHTML='<button type="button" class="cos-product-rail-prev" aria-label="Previous products">‹</button><button type="button" class="cos-product-rail-next" aria-label="Next products">›</button>'; holder.appendChild(controls);
      const update=()=>{controls.querySelector('.cos-product-rail-prev').disabled=rail.scrollLeft<8;controls.querySelector('.cos-product-rail-next').disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8};
      controls.addEventListener('click',(event)=>{const button=event.target.closest('button');if(!button)return;rail.scrollBy({left:(button.classList.contains('cos-product-rail-next')?1:-1)*Math.max(260,rail.clientWidth*.82),behavior:'smooth'})}); rail.addEventListener('scroll',update,{passive:true}); window.addEventListener('resize',update,{passive:true}); update();
    });
  };
  const buildDesktopFullNav = () => document.querySelectorAll('.cos-desktop-full-nav').forEach((bar) => bar.remove());  const prepareHamburger = () => document.querySelectorAll('.t4s-push-menu-btn').forEach((trigger)=>{trigger.removeAttribute('data-menu-drawer');trigger.removeAttribute('data-drawer-options');trigger.setAttribute('href','#categories');trigger.setAttribute('aria-label','Browse categories');trigger.dataset.cosOpenSheet='categories'});
  const init=()=>{buildMobileNavigation();replaceDesktopMenu();buildDesktopFullNav();enhanceProductRails();prepareHamburger()};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('click',(event)=>{const opener=event.target.closest('[data-cos-open-sheet]');if(opener&&mobileQuery.matches){event.preventDefault();event.stopImmediatePropagation();openSheet(opener.dataset.cosOpenSheet);return}if(event.target.closest('[data-cos-sheet-close]'))closeSheets()},true);
  document.addEventListener('keydown',(event)=>{if(event.key==='Escape')closeSheets()});
  new MutationObserver((mutations)=>mutations.forEach((mutation)=>mutation.addedNodes.forEach((node)=>{if(node.nodeType!==1)return;enhanceProductRails(node);replaceDesktopMenu();buildDesktopFullNav();if(node.matches?.('.t4s-push-menu-btn')||node.querySelector?.('.t4s-push-menu-btn'))prepareHamburger()}))).observe(document.documentElement,{childList:true,subtree:true});
})();